import api from '~/services/api'

const services = {
  newPassword(data) {
    return api.post('/student/password/new', data)
  },
}

export default services
